import { useMutation } from "@apollo/client/react";
import { useNotificationState } from "hooks/state";
import flatten from "lodash/flatten";
import values from "lodash/values";
import GqlError from "utils/GqlError";
import { DeleteLine } from "./line.gql";

export default function useDeleteLine() {
  const { setNotification } = useNotificationState();
  const [deleteLine] = useMutation(DeleteLine, {
    onCompleted: ({ deleteLine: { name } }) => {
      setNotification({
        title: `${name} was successfully deleted.`,
        type: "success",
      });
    },
    onError: (error) => {
      GqlError.handler(error, (errors) => {
        const allErrors = flatten(values(errors)).join("\n");

        setNotification({
          message: allErrors,
          title: "Unable to delete line",
          type: "danger",
        });
      });
    },
  });

  return (options) => deleteLine(options);
}
